// extracted by mini-css-extract-plugin
module.exports = {"intro_tooltip_class":"_2I8v9jnnPY2QJDG9pEXPi4"};